import { Button } from 'reactstrap'

export default function CustomSelectClearButton(props) {
  console.log('CustomSelectClearButton rendered: ', props)
  const { inputName, handleChange, clearSelections } = props

  function handleClear() {
    console.log('CustomSelectClearButton.handleClear')
    const event = { target: { name: inputName, selectedOptions: [], type: 'select-multiple' } }
    handleChange(event)
    clearSelections()
  }

  return (
    <Button color="secondary" size="sm" style={{ marginTop: '5px', marginBottom: '10px' }} onClick={handleClear}>Clear Selections</Button>
  )
}
